"use client"
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/index.tsx
import { SSRProvider } from "react-aria";

// src/components/Icon/Icon.tsx
import { twMerge } from "tailwind-merge";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
function getIcon(icon) {
  switch (icon) {
    case "account":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M17.265 15.603a1.102 1.102 0 1 0 1.224-1.832 1.102 1.102 0 0 0-1.224 1.832Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M3.736 5.879 14.032.732a2.217 2.217 0 0 1 1.682-.12 2.187 2.187 0 0 1 1.274 1.107l2.093 4.185a3.676 3.676 0 0 1 3.203 3.642v.861a2.206 2.206 0 0 1 1.468 2.077v4.406a2.207 2.207 0 0 1-1.468 2.077v.861A3.676 3.676 0 0 1 18.61 23.5H3.922A3.676 3.676 0 0 1 .25 19.828V9.546a3.676 3.676 0 0 1 3.486-3.667Zm13.688-.005-1.75-3.5a.728.728 0 0 0-.425-.368.739.739 0 0 0-.56.04L7.032 5.874h10.392Zm4.125 5.875H17.877a2.938 2.938 0 1 0 0 5.876h3.672a.736.736 0 0 0 .734-.735v-4.406a.735.735 0 0 0-.727-.735h-.007Zm-.734-2.203v.734h-2.938a4.407 4.407 0 0 0 0 8.814h2.938v.734a2.206 2.206 0 0 1-2.204 2.204H3.922a2.206 2.206 0 0 1-2.203-2.204V9.546a2.206 2.206 0 0 1 2.203-2.203h14.69a2.206 2.206 0 0 1 2.203 2.203Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "alert":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M11.24 17.341a1.079 1.079 0 0 1 1.841.763v.008a1.08 1.08 0 0 1-2.156 0v-.008c0-.286.113-.56.316-.762ZM11.494 15.382a.72.72 0 0 0 1.228-.508V8.406a.718.718 0 1 0-1.438 0v6.468c0 .19.076.373.21.508Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M13.099 1.519a2.157 2.157 0 0 0-2.195 0 2.157 2.157 0 0 0-.793.815v.005L.767 19.586a2.155 2.155 0 0 0 1.889 3.194h18.69a2.158 2.158 0 0 0 1.889-3.195L13.89 2.338v-.005a2.157 2.157 0 0 0-.792-.814Zm-.732 1.237c.11.065.201.158.263.27l9.35 17.25a.72.72 0 0 1-.628 1.068H2.662a.719.719 0 0 1-.63-1.066v-.005l9.343-17.247a.72.72 0 0 1 .992-.27Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "alertFilled":
      return /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M22.68 19.686 13.702 2.53a1.922 1.922 0 0 0-3.403 0L1.32 19.686a1.923 1.923 0 0 0 1.702 2.816h17.956a1.92 1.92 0 0 0 1.702-2.816ZM11.04 8.556a.961.961 0 1 1 1.92 0v5.767a.962.962 0 1 1-1.92 0V8.555Zm.981 11.062h.027a1.386 1.386 0 0 0 1.007-.442 1.41 1.41 0 0 0 .384-1.028 1.469 1.469 0 0 0-1.464-1.413h-.027c-.38.011-.74.17-1.004.442a1.435 1.435 0 0 0-.384 1.028 1.467 1.467 0 0 0 1.461 1.413Z",
          fillRule: "evenodd"
        }
      );
    case "arrowLeft":
      return /* @__PURE__ */ jsx("path", { d: "M11.667.877a.75.75 0 0 0-.947.093L.22 11.47a.75.75 0 0 0 0 1.06l10.5 10.5a.75.75 0 1 0 1.06-1.06l-9.22-9.22h20.69a.75.75 0 0 0 0-1.5H2.56l9.22-9.22a.75.75 0 0 0-.113-1.153Z" });
    case "arrowNavigateLeft":
      return /* @__PURE__ */ jsx("path", { d: "M4.213 16.444a.748.748 0 0 0 .287.057h.001a.75.75 0 0 0 .53-1.28l-2.47-2.47H23.25a.75.75 0 0 0 0-1.5H2.56l2.471-2.47A.75.75 0 1 0 3.97 7.72L.22 11.47a.75.75 0 0 0 .021 1.08l3.729 3.73c.07.07.152.125.243.163Z" });
    case "arrowNavigateRight":
      return /* @__PURE__ */ jsx("path", { d: "M19.787 7.557A.748.748 0 0 0 19.5 7.5h-.001a.75.75 0 0 0-.53 1.28l2.47 2.47H.75a.75.75 0 0 0 0 1.5h20.689l-2.47 2.47a.75.75 0 1 0 1.061 1.06l3.75-3.75a.75.75 0 0 0-.021-1.08L20.03 7.72a.748.748 0 0 0-.243-.163Z" });
    case "arrowRight":
      return /* @__PURE__ */ jsx("path", { d: "M12.333 23.123a.75.75 0 0 0 .948-.093l10.5-10.5a.748.748 0 0 0 0-1.06L13.28.97a.75.75 0 0 0-1.061 1.06l9.22 9.22H.75a.75.75 0 1 0 0 1.5h20.69l-9.22 9.22a.75.75 0 0 0 .113 1.153Z" });
    case "attach":
      return /* @__PURE__ */ jsx("path", { d: "M9.75 24a5.256 5.256 0 0 1-5.25-5.25V7.5a7.5 7.5 0 0 1 15 0v8.249a.75.75 0 0 1-1.5 0V7.5a6 6 0 0 0-12 0v11.25a3.75 3.75 0 1 0 7.5 0V7.5a1.5 1.5 0 1 0-3 0v9.75a.75.75 0 0 1-1.5 0V7.5a3 3 0 1 1 6 0v11.25A5.256 5.256 0 0 1 9.75 24Z" });
    case "bank":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M1.817 8.537a.727.727 0 0 1-.36-1.357l9.384-5.357a2.23 2.23 0 0 1 2.313 0l9.384 5.357a.727.727 0 0 1-.36 1.357H1.817Zm2.741-1.454h14.88L12.423 3.08l-.021-.013a.775.775 0 0 0-.81 0l-.02.013-7.015 4.004Z",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M22.177 22.499H1.817a.727.727 0 1 1 0-1.455h20.36a.727.727 0 0 1 0 1.455ZM17.814 19.706h2.909a.727.727 0 0 0 .727-.727v-8.377a.727.727 0 0 0-1.454 0v7.65h-1.454v-7.65a.727.727 0 0 0-1.455 0v8.377a.727.727 0 0 0 .727.727ZM13.451 19.706h-2.908a.727.727 0 0 1-.727-.727v-8.377a.727.727 0 1 1 1.454 0v7.65h1.454v-7.65a.727.727 0 1 1 1.455 0v8.377a.727.727 0 0 1-.728.727ZM3.271 19.706H6.18a.727.727 0 0 0 .727-.727v-8.377a.727.727 0 1 0-1.454 0v7.65H3.999v-7.65a.727.727 0 1 0-1.455 0v8.377a.727.727 0 0 0 .727.727Z" })
      ] });
    case "bankId":
      return /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M15.218 0H9.68l-.743 5.395h.952c.518 0 1.014-.259 1.219-.667a.79.79 0 0 0 .104-.331.62.62 0 0 0-.267-.5c-.371-.307-.434-.643-.434-.878V2.9c.083-.571.743-1.19 1.632-1.19.538 0 .93.144 1.177.403.209.24.309.571.246.902-.083.404-.434.735-.638.903-.539.427-.476.806-.434.926.104.331.538.547.868.547h1.448c1.962.024 3.018 1.047 2.667 3.47-.309 2.233-1.799 3.207-3.573 3.231l-.743 5.156h1.035c4.4 0 7.977-3.255 8.699-8.367C23.771 2.544 20.26 0 15.218 0ZM7.922 12.523l.91-6.677h-.993c-.455 0-1.052-.283-1.24-.83-.063-.192-.188-.83.58-1.45.267-.216.455-.45.476-.643a.541.541 0 0 0-.125-.499c-.146-.168-.476-.283-.89-.283-.7 0-1.197.475-1.239.806-.042.26.146.451.288.571.434.38.538.927.267 1.45-.288.523-.889.878-1.527.878H3.414c-.037.287-.329 2.429-.65 4.784-.399 2.929-.843 6.188-.898 6.621h5.46c.02-.331.266-2.232.596-4.728Zm-6.361 7.032h2.233c.952 0 1.177.547 1.115 1.07-.063.404-.288.716-.723.903.539.24.743.595.66 1.166-.104.716-.639 1.234-1.344 1.234H.96l.601-4.373Zm1.465 1.829c.434 0 .639-.26.68-.571.042-.331-.083-.571-.517-.571h-.392l-.167 1.142h.396Zm-.246 1.9c.455 0 .701-.215.764-.642.041-.356-.126-.596-.56-.596H2.55l-.167 1.234h.397v.005Zm5.163.692c-.58.048-.868-.024-.993-.307A1.721 1.721 0 0 1 5.935 24c-.66 0-.889-.38-.826-.83.02-.216.125-.404.309-.572.189-.19.54-.293.878-.392.29-.084.571-.166.733-.299.02-.307-.084-.427-.413-.427-.393 0-.702.144-1.26.571l.124-.998c.476-.403.931-.571 1.465-.571.68 0 1.282.307 1.157 1.166l-.126.974c-.041.332-.041.452.288.452l-.321.902Zm-.99-1.498c-.104.073-.239.119-.375.165-.266.09-.534.18-.576.479-.02.216.084.379.267.379.184 0 .413-.096.58-.24-.017-.061-.005-.14.012-.247l.01-.06.083-.476Zm3.244-1.924H9.04l-.476 3.374H9.72l.267-1.973c.167-.235.33-.355.518-.355.225 0 .309.168.267.5l-.246 1.852h1.156l.313-2.237c.104-.758-.209-1.21-.847-1.21-.376 0-.643.145-1.015.5l.063-.451Zm2.705-.999h1.16l-.288 2.16 1.114-1.166h1.428l-1.428 1.45 1.136 1.953h-1.465l-.89-1.57h-.02l-.209 1.57h-1.156l.618-4.397Zm5.438 0h-1.344l-.6 4.373h1.343l.601-4.373Zm.639 0h1.899c1.465 0 1.9 1.234 1.757 2.256-.125.999-.826 2.141-2.108 2.141H18.4l.58-4.397Zm1.24 3.35c.638 0 1.014-.355 1.114-1.142.084-.571-.083-1.142-.785-1.142h-.371l-.31 2.304.351-.02Z",
          fillRule: "evenodd"
        }
      );
    case "bankIdBrand":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "m7.922 12.523.91-6.677h-.993c-.455 0-1.052-.283-1.24-.83-.063-.192-.188-.83.58-1.45.267-.216.455-.45.476-.643a.541.541 0 0 0-.125-.499c-.146-.168-.476-.283-.89-.283-.7 0-1.197.475-1.239.806-.042.26.146.451.288.571.434.38.538.927.267 1.45-.288.523-.889.878-1.527.878H3.414c-.083.644-1.448 10.623-1.548 11.405h5.46c.02-.331.266-2.232.596-4.728Z",
            fill: "#459BBE"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M15.218 0H9.68l-.743 5.395h.952c.518 0 1.014-.259 1.219-.667a.79.79 0 0 0 .104-.331.62.62 0 0 0-.267-.5c-.371-.307-.434-.643-.434-.878V2.9c.083-.571.743-1.19 1.632-1.19.538 0 .93.144 1.177.403.209.24.309.571.246.902-.083.404-.434.735-.638.903-.539.427-.476.806-.434.926.104.331.538.547.868.547h1.448c1.962.024 3.018 1.047 2.667 3.47-.309 2.233-1.799 3.207-3.573 3.231l-.743 5.156h1.035c4.4 0 7.977-3.255 8.699-8.367C23.771 2.544 20.26 0 15.218 0Z",
            fill: "#235971"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M3.794 19.555H1.561L.96 23.928h2.542c.705 0 1.24-.518 1.344-1.234.083-.57-.121-.926-.66-1.166.435-.187.66-.5.723-.902.062-.524-.163-1.07-1.115-1.07Zm-.088 1.258c-.041.312-.246.571-.68.571H2.63l.167-1.142h.392c.434 0 .56.24.517.57Zm-.162 1.829c-.063.427-.31.643-.764.643v-.005h-.397l.167-1.234h.434c.434 0 .601.24.56.596ZM6.95 23.669c.125.283.413.355.993.307l.321-.902c-.33 0-.33-.12-.288-.452l.126-.974c.125-.86-.476-1.166-1.157-1.166-.534 0-.989.168-1.465.57l-.125 1c.56-.428.868-.572 1.26-.572.33 0 .435.12.414.427-.162.133-.443.215-.733.3-.338.098-.69.2-.878.391-.184.168-.288.356-.31.572-.062.45.168.83.827.83.376 0 .706-.115 1.015-.331Zm-.372-1.026c.136-.046.271-.092.376-.165l-.084.476a8.155 8.155 0 0 1-.01.06c-.016.107-.028.186-.01.247-.168.144-.397.24-.58.24-.184 0-.289-.163-.268-.38.042-.298.31-.389.576-.478Z",
            fill: "#459BBE",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M9.04 20.554h1.157l-.063.45c.372-.354.639-.498 1.015-.498.638 0 .951.45.847 1.21l-.313 2.236h-1.156l.246-1.853c.042-.331-.042-.499-.267-.499-.188 0-.35.12-.518.355l-.267 1.973H8.565l.476-3.374ZM14.062 19.555h-1.16l-.618 4.397h1.156l.209-1.57h.02l.89 1.57h1.465l-1.136-1.954 1.428-1.45h-1.428l-1.114 1.167.288-2.16ZM16.996 19.555h1.344l-.6 4.373h-1.345l.601-4.373Z",
            fill: "#459BBE"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M20.878 19.555h-1.9l-.58 4.397h2.13c1.28 0 1.982-1.142 2.107-2.14.142-1.023-.292-2.257-1.757-2.257Zm.455 2.208c-.1.787-.476 1.143-1.114 1.143l-.351.019.309-2.304h.371c.702 0 .869.571.785 1.142Z",
            fill: "#459BBE",
            fillRule: "evenodd"
          }
        )
      ] });
    case "calendar":
      return /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M16.5 3h-9V.75a.75.75 0 1 0-1.5 0V3H2.25A2.252 2.252 0 0 0 0 5.25v16.5A2.252 2.252 0 0 0 2.25 24h19.5A2.252 2.252 0 0 0 24 21.75V5.25A2.252 2.252 0 0 0 21.75 3H18V.75a.75.75 0 1 0-1.5 0V3ZM6.75 6.75A.75.75 0 0 1 6 6V4.5H2.25a.751.751 0 0 0-.75.75V9h21V5.25a.751.751 0 0 0-.75-.75H18V6a.75.75 0 1 1-1.5 0V4.5h-9V6a.75.75 0 0 1-.75.75ZM1.5 10.5h21v11.25a.751.751 0 0 1-.75.75H2.25a.751.751 0 0 1-.75-.75V10.5Z",
          fillRule: "evenodd"
        }
      );
    case "calendarArrowRight":
      return /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M5.243 4.5a.75.75 0 0 1-.75-.75v-.74H2.25a.751.751 0 0 0-.75.75V6h15V3.76a.751.751 0 0 0-.75-.75h-2.257v.74a.75.75 0 1 1-1.5 0v-.74h-6v.74a.75.75 0 0 1-.75.75Zm6.75-2.99h-6V.75a.75.75 0 1 0-1.5 0v.76H2.25A2.252 2.252 0 0 0 0 3.76v11.99A2.252 2.252 0 0 0 2.25 18h6v-.005a.75.75 0 0 0 0-1.5h-6a.75.75 0 0 1-.75-.75V7.5h15v.745a.75.75 0 1 0 1.5 0V3.76a2.252 2.252 0 0 0-2.25-2.25h-2.257V.75a.75.75 0 1 0-1.5 0v.76ZM13.5 22.862A6.75 6.75 0 0 0 17.25 24 6.758 6.758 0 0 0 24 17.25a6.75 6.75 0 1 0-10.5 5.612Zm.833-9.977a5.25 5.25 0 1 1 5.834 8.73 5.25 5.25 0 0 1-5.834-8.73Zm2.917 6.614a.747.747 0 0 1 .22-.53l.97-.97h-4.19a.75.75 0 1 1 0-1.5h4.188l-.97-.969a.748.748 0 0 1-.091-.947.75.75 0 0 1 1.153-.114l2.226 2.227a.75.75 0 0 1 .024 1.084l-2.25 2.25a.749.749 0 0 1-1.28-.53Z",
          fillRule: "evenodd"
        }
      );
    case "card":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M13.5 13.5H5.25a.75.75 0 0 1 0-1.5h8.25a.75.75 0 0 1 0 1.5ZM5.25 16.5h5.25a.75.75 0 0 0 0-1.5H5.25a.75.75 0 0 0 0 1.5Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M21.75 3H2.25A2.253 2.253 0 0 0 0 5.25v13.5A2.253 2.253 0 0 0 2.25 21h19.5A2.253 2.253 0 0 0 24 18.75V5.25A2.253 2.253 0 0 0 21.75 3Zm.75 4.5V5.25a.751.751 0 0 0-.75-.75H2.25a.751.751 0 0 0-.75.75V7.5h21ZM1.5 9h21v9.75a.751.751 0 0 1-.75.75H2.25a.751.751 0 0 1-.75-.75V9Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "checkmark":
      return /* @__PURE__ */ jsx("path", { d: "M22.901.771a1.437 1.437 0 0 0-2.005.326L7.445 19.86l-4.49-4.497A1.437 1.437 0 1 0 .92 17.396L6.61 23.09a1.46 1.46 0 0 0 2.184-.182l14.44-20.134A1.438 1.438 0 0 0 22.9.77Z" });
    case "chevronDown":
      return /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M6.374 8.5a.885.885 0 0 1 .613.247L12 13.582l5.012-4.836a.882.882 0 0 1 1.225 0 .856.856 0 0 1 0 1.232l-5.36 5.17A1.264 1.264 0 0 1 12 15.5c-.326 0-.642-.125-.877-.352l-5.36-5.17a.859.859 0 0 1-.194-.951.865.865 0 0 1 .326-.386.885.885 0 0 1 .48-.141Z",
          fillRule: "evenodd"
        }
      );
    case "chevronLeft":
      return /* @__PURE__ */ jsx("path", { d: "M14.973 5.57c.16.067.293.182.386.325a.885.885 0 0 1-.106 1.092L10.418 12l4.836 5.012a.882.882 0 0 1 0 1.225.855.855 0 0 1-1.232 0l-5.17-5.36A1.264 1.264 0 0 1 8.5 12c0-.326.125-.642.352-.877l5.17-5.36a.86.86 0 0 1 .951-.194Z" });
    case "chevronRight":
      return /* @__PURE__ */ jsx("path", { d: "M8.746 5.763a.856.856 0 0 1 1.232 0l5.17 5.36c.227.235.352.551.352.877 0 .326-.125.642-.352.877l-5.17 5.36a.859.859 0 0 1-.951.194.865.865 0 0 1-.386-.326.885.885 0 0 1 .106-1.092L13.582 12 8.746 6.988a.882.882 0 0 1 0-1.225Z" });
    case "chevronUp":
      return /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M11.123 8.852c.235-.227.551-.352.877-.352.326 0 .642.125.877.352l5.36 5.17a.859.859 0 0 1 .194.951.865.865 0 0 1-.326.386.885.885 0 0 1-1.092-.105L12 10.418l-5.012 4.836a.882.882 0 0 1-1.225 0 .855.855 0 0 1 0-1.232l5.36-5.17Z",
          fillRule: "evenodd"
        }
      );
    case "delete":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M9.281 17.652a.733.733 0 0 0 1.252-.519V9.8a.733.733 0 1 0-1.466 0v7.333c0 .195.077.381.214.519ZM14.2 17.867a.733.733 0 0 1-.733-.734V9.8a.733.733 0 1 1 1.466 0v7.333a.733.733 0 0 1-.733.734Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M9.8 1h4.4a2.202 2.202 0 0 1 2.2 2.2v.733h5.867a.733.733 0 0 1 0 1.467H20.74l-1.298 15.583A2.214 2.214 0 0 1 17.25 23H6.75a2.212 2.212 0 0 1-2.193-2.018L3.258 5.4H1.734a.733.733 0 0 1 0-1.467H7.6V3.2A2.202 2.202 0 0 1 9.8 1Zm5.133 2.933V3.2a.734.734 0 0 0-.733-.733H9.8a.734.734 0 0 0-.733.733v.733h5.866Zm-8.91 16.928L4.736 5.4h14.54l-1.288 15.46a.739.739 0 0 1-.731.673h-10.5a.728.728 0 0 1-.732-.672Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "delivery":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M14.863 3c.421 0 .837.097 1.213.285l5.937 3.01c.451.229.829.577 1.091 1.007.263.43.4.923.396 1.425v6.542c.003.5-.134.993-.395 1.421a2.725 2.725 0 0 1-1.088 1.006l-5.941 3.01a2.68 2.68 0 0 1-1.129.29.72.72 0 0 1-.168 0 2.68 2.68 0 0 1-1.13-.29l-5.937-3.007a2.731 2.731 0 0 1-1.09-1.007 2.7 2.7 0 0 1-.397-1.425V8.724c-.003-.5.133-.992.395-1.42a2.726 2.726 0 0 1 1.086-1.007l5.943-3.01A2.695 2.695 0 0 1 14.863 3Zm6.495 13.43-5.775 2.927v-7.422l2.519-1.276v1.605c0 .19.076.37.21.505a.723.723 0 0 0 1.018 0 .711.711 0 0 0 .211-.505V9.93l2.517-1.275.002.072v6.55a1.28 1.28 0 0 1-.702 1.154ZM7.667 8.655l6.476 3.28v7.422l-5.771-2.923a1.3 1.3 0 0 1-.707-1.16v-6.55c0-.023 0-.046.002-.069Zm.86-1.166 2.376-1.204 6.336 3.21-2.376 1.203-6.335-3.21Zm10.294 1.204-6.336-3.21 1.82-.921a1.235 1.235 0 0 1 1.115 0l5.778 2.927-2.377 1.204Z",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M4.065 7.917a.72.72 0 0 1-.377-.107l-1.62-.99a.718.718 0 0 1-.334-.722.71.71 0 0 1 .545-.58.726.726 0 0 1 .544.086l1.62.99a.715.715 0 0 1 .316.804.714.714 0 0 1-.694.519ZM3.667 11.43a.722.722 0 0 0 1.038-.455.708.708 0 0 0-.358-.803L1.648 8.739a.725.725 0 0 0-.96.299.708.708 0 0 0 .28.959l2.7 1.433ZM3.71 15.214a.723.723 0 0 0 1.025-.47.708.708 0 0 0-.375-.803l-2.819-1.415a.725.725 0 0 0-.963.316.708.708 0 0 0 .313.957l2.818 1.415Z" })
      ] });
    case "document":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M16.385 11.271h-8.77a.73.73 0 0 1 0-1.461h8.77a.73.73 0 1 1 0 1.461ZM16.385 14.925h-8.77a.73.73 0 0 1 0-1.461h8.77a.73.73 0 0 1 0 1.461ZM7.615 18.58h8.77a.73.73 0 0 0 0-1.462h-8.77a.73.73 0 0 0 0 1.461ZM11.391 5.24a1.096 1.096 0 1 0 1.218-1.823 1.096 1.096 0 0 0-1.218 1.824Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M12 .31a4.391 4.391 0 0 1 4.324 3.654h2.984A2.195 2.195 0 0 1 21.5 6.156v15.346a2.195 2.195 0 0 1-2.192 2.193H4.692A2.195 2.195 0 0 1 2.5 21.502V6.156a2.195 2.195 0 0 1 2.192-2.192h2.985A4.392 4.392 0 0 1 12 .31Zm7.308 21.923a.732.732 0 0 0 .73-.73V6.155a.732.732 0 0 0-.73-.73h-3.654a.73.73 0 0 1-.73-.731 2.923 2.923 0 0 0-5.847 0 .73.73 0 0 1-.73.73H4.691a.732.732 0 0 0-.73.731v15.346a.732.732 0 0 0 .73.731h14.616Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "documentAdd":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M.66 23.34c.422.422.994.66 1.59.66h7.5a.75.75 0 1 0 0-1.5h-7.5a.751.751 0 0 1-.75-.75V6.002a.75.75 0 0 1 .75-.75H6a.75.75 0 0 0 .75-.75 3 3 0 0 1 6 0 .75.75 0 0 0 .75.75h3.751a.751.751 0 0 1 .75.75v2.25a.75.75 0 1 0 1.5 0v-2.25a2.253 2.253 0 0 0-2.25-2.25h-3.063a4.5 4.5 0 0 0-8.875 0H2.25A2.253 2.253 0 0 0 0 6.002V21.75c0 .597.238 1.169.66 1.59Z" }),
        /* @__PURE__ */ jsx("path", { d: "M5.25 11.251h5.25a.75.75 0 1 0 0-1.5H5.25a.75.75 0 1 0 0 1.5ZM4.72 14.781c.14.141.331.22.53.22h3a.75.75 0 1 0 0-1.5h-3a.75.75 0 0 0-.53 1.28ZM8.78 18.53a.75.75 0 0 1-.53.22h-3a.75.75 0 1 1 0-1.5h3a.75.75 0 0 1 .53 1.28ZM9.75 5.252a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25ZM17.25 21a.75.75 0 0 1-.75-.75V18h-2.25a.75.75 0 1 1 0-1.5h2.25v-2.249a.75.75 0 1 1 1.5 0v2.25h2.25a.75.75 0 1 1 0 1.5H18v2.25a.75.75 0 0 1-.75.75Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M13.5 22.863A6.75 6.75 0 0 0 17.25 24 6.758 6.758 0 0 0 24 17.25a6.749 6.749 0 0 0-11.523-4.772A6.75 6.75 0 0 0 13.5 22.863Zm.833-9.977a5.25 5.25 0 1 1 5.834 8.73 5.25 5.25 0 0 1-5.834-8.73Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "download":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M11.999 16.5a.77.77 0 0 1-.218-.032.751.751 0 0 1-.33-.206L6.97 11.78a.75.75 0 0 1 1.061-1.061l3.219 3.219V3.75a.75.75 0 1 1 1.5 0v10.19l3.221-3.221a.75.75 0 0 1 1.061 1.061l-4.5 4.5a.746.746 0 0 1-.532.22Z" }),
        /* @__PURE__ */ jsx("path", { d: "M3.75 21h16.5A3.754 3.754 0 0 0 24 17.25v-1.5a.75.75 0 0 0-1.5 0v1.5a2.253 2.253 0 0 1-2.25 2.25H3.75a2.253 2.253 0 0 1-2.25-2.25v-1.5a.75.75 0 0 0-1.5 0v1.5A3.754 3.754 0 0 0 3.75 21Z" })
      ] });
    case "edit":
      return /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M21.299.33A4.36 4.36 0 0 0 19.624 0l-.028.004a4.42 4.42 0 0 0-3.1 1.318l-.329.328a.748.748 0 0 0-.172.171L14.088 3.73a.754.754 0 0 0-.195.195L2.09 15.724a.749.749 0 0 0-.304.476L.024 23.064a.75.75 0 0 0 .913.912l6.9-1.77a.752.752 0 0 0 .344-.2l14.5-14.495a4.387 4.387 0 0 0 .038-6.232 4.36 4.36 0 0 0-1.42-.949ZM2.919 17.79l-1.131 4.412L6.2 21.068 2.92 17.79Zm4.742 2.611 10.924-10.92-4.072-4.07-10.93 10.923L7.662 20.4ZM15.574 4.35l4.072 4.07 1.03-1.03-4.071-4.07-1.031 1.03Zm6.162 1.977a2.886 2.886 0 0 0-.078-3.989 2.867 2.867 0 0 0-2.034-.838h-.021a2.908 2.908 0 0 0-1.935.76l4.068 4.067Z",
          fillRule: "evenodd"
        }
      );
    case "ellipsis":
      return /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M3.996 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM19.996 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
          fillRule: "evenodd"
        }
      );
    case "email":
      return /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M20.8 4H3.2a2.212 2.212 0 0 0-1.727.832A2.173 2.173 0 0 0 1 6.182v11.636c0 .579.233 1.133.645 1.542.413.41.972.64 1.555.64h17.6c.583 0 1.142-.23 1.555-.64.412-.409.644-.963.645-1.542V6.182a2.174 2.174 0 0 0-.645-1.542A2.212 2.212 0 0 0 20.8 4Zm-.32 1.455H3.521l6.954 5.304a2.517 2.517 0 0 0 3.05 0l6.953-5.304ZM2.466 6.485v11.333c0 .193.077.378.215.514a.738.738 0 0 0 .518.213h17.6c.194 0 .38-.077.518-.213a.725.725 0 0 0 .215-.514V6.486l-7.113 5.426a3.984 3.984 0 0 1-2.42.815 3.983 3.983 0 0 1-2.419-.815L2.467 6.485Z",
          fillRule: "evenodd"
        }
      );
    case "externalLink":
      return /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M14.5.75a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 .75.75v7.871a.75.75 0 0 1-1.5 0V2.54L9.776 15.058a.75.75 0 1 1-1.052-1.07L21.418 1.5H15.25a.75.75 0 0 1-.75-.75ZM.476 5.476A1.625 1.625 0 0 1 1.625 5h10.5a.75.75 0 0 1 0 1.5h-10.5a.125.125 0 0 0-.125.125v15.75a.125.125 0 0 0 .125.125h15.75a.125.125 0 0 0 .125-.125v-10.5a.75.75 0 0 1 1.5 0v10.5A1.625 1.625 0 0 1 17.375 24H1.625A1.625 1.625 0 0 1 0 22.375V6.625c0-.431.171-.844.476-1.149Z",
          fillRule: "evenodd"
        }
      );
    case "faq":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M12.75 12a.75.75 0 0 1-.75-.75v-.257a2.253 2.253 0 0 1 1.5-2.121 2.25 2.25 0 1 0-3-2.122.75.75 0 1 1-1.5 0 3.75 3.75 0 0 1 7.191-1.49c.273.631.368 1.325.273 2.006A3.75 3.75 0 0 1 14 10.286a.751.751 0 0 0-.5.707v.257a.75.75 0 0 1-.75.75ZM12.125 15.56a1.125 1.125 0 1 0 1.25-1.87 1.125 1.125 0 0 0-1.25 1.87Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M4.72 23.78a.75.75 0 0 0 .98.07l5.8-4.35h10.25A2.253 2.253 0 0 0 24 17.25v-15A2.253 2.253 0 0 0 21.75 0H2.25A2.253 2.253 0 0 0 0 2.25v15a2.253 2.253 0 0 0 2.25 2.25H4.5v3.75c0 .199.079.39.22.53Zm-3-22.06c.14-.14.331-.22.53-.22h19.5a.751.751 0 0 1 .75.75v15a.751.751 0 0 1-.75.75h-10.5a.75.75 0 0 0-.45.15L6 21.75v-3a.75.75 0 0 0-.75-.75h-3a.751.751 0 0 1-.75-.75v-15c0-.199.08-.39.22-.53Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "file":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M6.17733 9.088H17.9107C18.1052 9.088 18.2917 9.01383 18.4292 8.8818C18.5667 8.74979 18.644 8.57072 18.644 8.384C18.644 8.19729 18.5667 8.01822 18.4292 7.8862C18.2917 7.75417 18.1052 7.68 17.9107 7.68H6.17733C5.98284 7.68 5.79631 7.75417 5.65878 7.8862C5.52126 8.01822 5.444 8.19729 5.444 8.384C5.444 8.57072 5.52126 8.74979 5.65878 8.8818C5.79631 9.01383 5.98284 9.088 6.17733 9.088Z" }),
        /* @__PURE__ */ jsx("path", { d: "M17.9107 13.312H6.17733C5.98284 13.312 5.79631 13.2378 5.65878 13.1058C5.52126 12.9738 5.444 12.7947 5.444 12.608C5.444 12.4212 5.52126 12.2422 5.65878 12.1102C5.79631 11.9782 5.98284 11.904 6.17733 11.904H17.9107C18.1052 11.904 18.2917 11.9782 18.4292 12.1102C18.5667 12.2422 18.644 12.4212 18.644 12.608C18.644 12.7947 18.5667 12.9738 18.4292 13.1058C18.2917 13.2378 18.1052 13.312 17.9107 13.312Z" }),
        /* @__PURE__ */ jsx("path", { d: "M6.17733 17.536H12.044C12.2385 17.536 12.425 17.4618 12.5625 17.3298C12.7 17.1977 12.7773 17.0187 12.7773 16.832C12.7773 16.6452 12.7 16.4662 12.5625 16.3342C12.425 16.2021 12.2385 16.128 12.044 16.128H6.17733C5.98284 16.128 5.79631 16.2021 5.65878 16.3342C5.52126 16.4662 5.444 16.6452 5.444 16.832C5.444 17.0187 5.52126 17.1977 5.65878 17.3298C5.79631 17.4618 5.98284 17.536 6.17733 17.536Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M3.2 23.168H20.8C21.3832 23.1673 21.9424 22.9445 22.3548 22.5486C22.7672 22.1527 22.9992 21.6159 23 21.056V5.45817C22.9995 5.17641 22.9406 4.89757 22.8266 4.63792C22.7126 4.37828 22.5459 4.14305 22.3361 3.94599L19.4477 1.23981C19.0372 0.854014 18.4852 0.638583 17.9107 0.639999H3.2C2.61676 0.640744 2.05763 0.863491 1.64522 1.25941C1.23281 1.65532 1.00078 2.19209 1 2.752V21.056C1.00078 21.6159 1.23281 22.1527 1.64522 22.5486C2.05763 22.9445 2.61676 23.1673 3.2 23.168ZM2.68175 2.25447C2.81922 2.1225 3.00559 2.04825 3.2 2.048H17.9107C18.102 2.04858 18.2856 2.12025 18.423 2.24795L21.3123 4.95503C21.3821 5.02061 21.4376 5.09888 21.4756 5.18526C21.5135 5.27165 21.5331 5.36442 21.5333 5.45817V21.056C21.5331 21.2426 21.4557 21.4215 21.3183 21.5535C21.1808 21.6855 20.9944 21.7597 20.8 21.76H3.2C3.00559 21.7597 2.81922 21.6855 2.68175 21.5535C2.54428 21.4215 2.46693 21.2426 2.46667 21.056V2.752C2.46693 2.56536 2.54428 2.38645 2.68175 2.25447Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "filter":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M13.4 16.5h5.35a.75.75 0 0 0 0-1.5H13.4a3 3 0 0 0-5.81 0H5.25a.75.75 0 0 0 0 1.5h2.34a3 3 0 0 0 5.81 0Zm-4.404-.673A1.5 1.5 0 0 0 10.5 17.25h-.006a1.5 1.5 0 1 0-1.498-1.577.75.75 0 0 1 0 .154ZM13.595 9H5.25a.75.75 0 0 1 0-1.5h8.345a3 3 0 1 1 0 1.5Zm3.857.41a1.5 1.5 0 1 1-1.903-2.32 1.5 1.5 0 0 1 1.903 2.32Z",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M21.75 0H2.25A2.253 2.253 0 0 0 0 2.25v19.5A2.253 2.253 0 0 0 2.25 24h19.5A2.253 2.253 0 0 0 24 21.75V2.25A2.253 2.253 0 0 0 21.75 0Zm.53 22.28a.751.751 0 0 1-.53.22H2.25a.751.751 0 0 1-.75-.75V2.25a.751.751 0 0 1 .75-.75h19.5a.751.751 0 0 1 .75.75v19.5c0 .199-.08.39-.22.53Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "globe":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M12 24a12 12 0 1 1 8.485-3.514A11.921 11.921 0 0 1 12 24Zm0-22.5A10.5 10.5 0 1 0 22.5 12 10.512 10.512 0 0 0 12 1.5Z" }),
        /* @__PURE__ */ jsx("path", { d: "M9.29 23.672a.749.749 0 0 1-.62-.328C7 20.893 6 16.648 6 12.001S7 3.109 8.669.657a.75.75 0 0 1 1.239.845c-1.486 2.179-2.409 6.2-2.409 10.5s.923 8.32 2.409 10.5a.75.75 0 0 1-.619 1.173l.001-.003Z" }),
        /* @__PURE__ */ jsx("path", { d: "M23.25 12.748H.75a.75.75 0 1 1 0-1.5h22.5a.75.75 0 0 1 0 1.5ZM21.518 18.748H2.482a.75.75 0 1 1 0-1.5h19.036a.75.75 0 0 1 0 1.5ZM21.518 6.748H2.482a.75.75 0 1 1 0-1.5h19.036a.75.75 0 0 1 0 1.5Z" }),
        /* @__PURE__ */ jsx("path", { d: "M14.71 23.672a.75.75 0 0 1-.619-1.173c1.486-2.18 2.409-6.2 2.409-10.5s-.923-8.32-2.409-10.5A.75.75 0 0 1 15.33.654C17 3.109 18 7.348 18 12s-1 8.892-2.669 11.344a.749.749 0 0 1-.621.327Z" })
      ] });
    case "information":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M11.626 8.25a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25ZM14.25 17.25h-.75A2.253 2.253 0 0 1 11.25 15v-3.75h-.75a.75.75 0 0 1 0-1.5h.75a1.5 1.5 0 0 1 1.5 1.5V15a.75.75 0 0 0 .75.75h.75a.75.75 0 0 1 0 1.5Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M4.388 21.276A12 12 0 0 0 12 24a11.92 11.92 0 0 0 8.485-3.515 12 12 0 1 0-16.098.791ZM6.168 3.27A10.5 10.5 0 0 1 12 1.5 10.512 10.512 0 0 1 22.5 12 10.5 10.5 0 1 1 6.167 3.27Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "invoice":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M13.28 11.655a2.909 2.909 0 0 1-1.671-1.074.733.733 0 1 1 1.167-.888 1.44 1.44 0 0 0 1.237.566h.031c.738-.012 1.248-.415 1.248-.78 0-.372-.526-.783-1.28-.783a3.116 3.116 0 0 1-1.865-.586 1.993 1.993 0 0 1 0-3.313 3.115 3.115 0 0 1 1.132-.51v-.351a.733.733 0 1 1 1.467 0v.345a2.906 2.906 0 0 1 1.666 1.074.733.733 0 0 1-1.168.887 1.44 1.44 0 0 0-1.231-.565h-.043c-.733.014-1.241.416-1.241.78 0 .372.527.783 1.283.783a3.112 3.112 0 0 1 1.864.586 1.993 1.993 0 0 1 0 3.311c-.341.245-.726.417-1.13.51V12a.733.733 0 1 1-1.467 0v-.346ZM7.598 5.402h1.467a.733.733 0 1 0 0-1.466H7.598a.733.733 0 1 0 0 1.466ZM9.065 8.335H7.598a.733.733 0 0 1 0-1.467h1.467a.733.733 0 0 1 0 1.467ZM7.598 11.267h1.467a.733.733 0 0 0 0-1.466H7.598a.733.733 0 1 0 0 1.466Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M3.933 11.343V2.469A2.202 2.202 0 0 1 6.132.27h11.73a2.202 2.202 0 0 1 2.2 2.2v8.875l.554-.44a1.466 1.466 0 0 1 2.378 1.148v9.482a2.203 2.203 0 0 1-2.2 2.195H3.2A2.202 2.202 0 0 1 1 21.53V12.05a1.466 1.466 0 0 1 1.466-1.466v.002c.332 0 .653.112.912.318l.555.44Zm15.809 2.123-2.923 2.318 2.295 2.295a.733.733 0 0 1-.518 1.251l-.001.001a.731.731 0 0 1-.518-.215l-2.415-2.414-1.398 1.11a3.667 3.667 0 0 1-4.531 0L8.334 16.7l-2.416 2.416a.73.73 0 0 1-.926.09.733.733 0 0 1-.111-1.127l2.297-2.297-2.897-2.298a.735.735 0 0 1-.134-.106l-.002-.003-1.679-1.332v9.482a.734.734 0 0 0 .733.733l17.595.005a.734.734 0 0 0 .733-.733v-9.482L19.825 13.4a.738.738 0 0 1-.082.065ZM8.716 15.137 5.4 12.506V2.469a.734.734 0 0 1 .733-.733h11.73a.734.734 0 0 1 .733.733v10.039l-3.287 2.607a.73.73 0 0 0-.086.068l-1.866 1.48a2.2 2.2 0 0 1-2.715 0L8.745 15.16a.749.749 0 0 0-.029-.023Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "invoiceFee":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M21.917 16.5H16.5a.75.75 0 1 1 0-1.5h5.417a.584.584 0 0 0 .583-.583V4.636a.577.577 0 0 0-.17-.412l-2.553-2.553a.578.578 0 0 0-.413-.171h-6.781a.584.584 0 0 0-.583.583V12.75a.75.75 0 1 1-1.5 0V2.083A2.085 2.085 0 0 1 12.583 0h6.781a2.067 2.067 0 0 1 1.474.612l2.551 2.551A2.064 2.064 0 0 1 24 4.636v9.781a2.085 2.085 0 0 1-2.083 2.083Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M3.75 24h-3a.75.75 0 1 1 0-1.5h3a.751.751 0 0 0 .75-.75v-6a.751.751 0 0 0-.75-.75h-3a.75.75 0 1 1 0-1.5h3A2.253 2.253 0 0 1 5.87 15h4.63a3.757 3.757 0 0 1 3.675 3h3.075A3.754 3.754 0 0 1 21 21.75a.75.75 0 0 1-.75.75H5.87A2.252 2.252 0 0 1 3.75 24ZM6 21h13.371a2.254 2.254 0 0 0-2.121-1.5H10.5a.75.75 0 1 1 0-1.5h2.12a2.251 2.251 0 0 0-2.12-1.5H6V21Z",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M2 20.81a1.125 1.125 0 1 0 1.25-1.87A1.125 1.125 0 0 0 2 20.81Z" })
      ] });
    case "locked":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M11.47 18.53a.75.75 0 0 0 1.28-.53v-3a.75.75 0 0 0-1.5 0v3c0 .199.079.39.22.53Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M6 6v3h-.75A2.253 2.253 0 0 0 3 11.25v10.5A2.253 2.253 0 0 0 5.25 24h13.5A2.253 2.253 0 0 0 21 21.75v-10.5A2.253 2.253 0 0 0 18.75 9H18V6A6 6 0 0 0 6 6Zm-1.28 4.72c.14-.14.331-.22.53-.22h13.5a.751.751 0 0 1 .75.75v10.5a.751.751 0 0 1-.75.75H5.25a.751.751 0 0 1-.75-.75v-10.5c0-.199.08-.39.22-.53ZM16.5 6v3h-9V6a4.5 4.5 0 1 1 9 0Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "logOut":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M7 21.146a10.768 10.768 0 0 0 5.72 1.635A10.78 10.78 0 1 0 7.055 2.829 10.78 10.78 0 0 0 3.205 6.93a.719.719 0 1 0 1.268.677 9.34 9.34 0 1 1-.16 8.488.718.718 0 0 0-1.292.628 10.767 10.767 0 0 0 3.98 4.423Z" }),
        /* @__PURE__ */ jsx("path", { d: "M12.714 16.313a.72.72 0 0 1-.508-1.227l2.363-2.362H1.219a.719.719 0 0 1 0-1.437h13.357l-2.37-2.37a.719.719 0 1 1 1.017-1.016l3.592 3.592a.719.719 0 0 1 0 1.02.7.7 0 0 1-.045.041l-3.547 3.548a.716.716 0 0 1-.51.21Z" })
      ] });
    case "message":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M8.333 6.131h2.934a.733.733 0 1 0 0-1.466H8.333a.733.733 0 0 0 0 1.466ZM8.333 9.064a.733.733 0 0 1 0-1.467h7.334a.733.733 0 1 1 0 1.467H8.333ZM7.815 11.781a.733.733 0 0 0 .518.215h7.334a.733.733 0 1 0 0-1.466H8.333a.733.733 0 0 0-.518 1.251Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M3.933 2.465v8.874l-.556-.441a1.473 1.473 0 0 0-.91-.317v-.003A1.467 1.467 0 0 0 1 12.045v9.481a2.202 2.202 0 0 0 2.2 2.2h17.6A2.203 2.203 0 0 0 23 21.53V12.05a1.466 1.466 0 0 0-2.378-1.149l-.555.44V2.465a2.202 2.202 0 0 0-2.2-2.2H6.133a2.203 2.203 0 0 0-2.2 2.2Zm10.335 15.342 5.48-4.346a.722.722 0 0 0 .08-.065l1.705-1.351v9.481a.734.734 0 0 1-.733.733l-17.6-.004a.735.735 0 0 1-.733-.733V12.04l1.679 1.332.002.002c.04.041.086.077.134.106l5.453 4.327a3.665 3.665 0 0 0 4.533 0ZM18.6 2.465v10.04l-5.24 4.155a2.199 2.199 0 0 1-2.716 0L5.4 12.502V2.465a.734.734 0 0 1 .733-.733h11.734a.734.734 0 0 1 .733.733Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "navigationMenu":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M2.25 5.25301C1.83579 5.25301 1.5 5.58879 1.5 6.00301C1.5 6.41722 1.83579 6.75301 2.25 6.75301H21.75C22.1642 6.75301 22.5 6.41722 22.5 6.00301C22.5 5.58879 22.1642 5.25301 21.75 5.25301H2.25Z" }),
        /* @__PURE__ */ jsx("path", { d: "M1.5 12.003C1.5 11.5888 1.83579 11.253 2.25 11.253H21.75C22.1642 11.253 22.5 11.5888 22.5 12.003C22.5 12.4172 22.1642 12.753 21.75 12.753H2.25C1.83579 12.753 1.5 12.4172 1.5 12.003Z" }),
        /* @__PURE__ */ jsx("path", { d: "M1.5 18.003C1.5 17.5888 1.83579 17.253 2.25 17.253H21.75C22.1642 17.253 22.5 17.5888 22.5 18.003C22.5 18.4172 22.1642 18.753 21.75 18.753H2.25C1.83579 18.753 1.5 18.4172 1.5 18.003Z" })
      ] });
    case "notifications":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M12.73 2.285V.75a.75.75 0 1 0-1.5 0v1.535a8.26 8.26 0 0 0-7.499 8.211c0 5.741-1.27 7.683-1.345 7.793a.732.732 0 0 0 .19 1.095.753.753 0 0 0 .404.112h18a.773.773 0 0 0 .76-.518.7.7 0 0 0-.27-.8c-.145-.178-1.24-1.733-1.24-7.678a8.26 8.26 0 0 0-7.5-8.215ZM11.97 3.75a.774.774 0 0 0 .023 0 6.75 6.75 0 0 1 6.738 6.75c0 4.053.491 6.288.964 7.5H4.19a21.345 21.345 0 0 0 1.041-7.5 6.75 6.75 0 0 1 6.739-6.75Z",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M11.982 24a2.852 2.852 0 0 1-2.722-2.038.749.749 0 1 1 1.44-.422 1.337 1.337 0 0 0 2.565 0 .75.75 0 0 1 1.44.423A2.853 2.853 0 0 1 11.981 24Z" })
      ] });
    case "pending":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M16.811 17.507a.719.719 0 0 1-.175-1.416 7.188 7.188 0 1 0-8.135-3.642.72.72 0 1 1-1.274.665 8.626 8.626 0 1 1 9.762 4.374.714.714 0 0 1-.178.019Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M1.219 23.497A.719.719 0 0 1 .5 22.78v-8.626a.718.718 0 1 1 1.438 0v.72H6.25a3.6 3.6 0 0 1 3.522 2.874h2.947a3.598 3.598 0 0 1 3.594 3.594.719.719 0 0 1-.719.72H1.938v.718a.719.719 0 0 1-.72.718Zm.719-2.874V16.31H6.25a2.158 2.158 0 0 1 2.033 1.437H6.25a.719.719 0 0 0 0 1.438H12.72a2.16 2.16 0 0 1 2.033 1.438H1.938Z",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M14.157 10.56h3.594a.719.719 0 0 0 0-1.438h-2.875V4.091a.719.719 0 1 0-1.438 0v5.75a.719.719 0 0 0 .719.719Z" })
      ] });
    case "percentage":
      return /* @__PURE__ */ jsx("path", { d: "M3.816 2a1.816 1.816 0 0 0-.695 3.492 1.816 1.816 0 0 0 1.704-3.186c-.299-.2-.65-.306-1.01-.306ZM21.624 3.833a.915.915 0 1 0-1.296-1.295L2.532 20.329a.915.915 0 1 0 1.296 1.295L21.624 3.833ZM20.186 18.37a1.816 1.816 0 1 0 0 3.632 1.816 1.816 0 0 0 0-3.632Z" });
    case "phone":
      return /* @__PURE__ */ jsx("path", { d: "M16.484 23.5a9.7 9.7 0 0 1-1.164-.07l-.06-.008c-.469-.06-.934-.151-1.392-.273A21.751 21.751 0 0 1 .848 10.13a9.762 9.762 0 0 1 1.746-8.622l.006-.01a2.53 2.53 0 0 1 3.812-.248l3.712 3.713a2.528 2.528 0 0 1 0 3.575l-1.908 1.911a4.359 4.359 0 0 1-3.06 1.268 4.296 4.296 0 0 1-2.523-.81A21.676 21.676 0 0 0 13.097 21.37a4.33 4.33 0 0 1 .458-5.583l1.91-1.91a2.546 2.546 0 0 1 1.787-.742 2.513 2.513 0 0 1 1.788.742l3.713 3.714a2.53 2.53 0 0 1-.25 3.81l-.01.006a10 10 0 0 1-6.01 2.093Zm-.776-1.493a7.96 7.96 0 0 0 2.214-.097 9.086 9.086 0 0 0 3.697-1.673 1.077 1.077 0 0 0 .097-1.618l-3.715-3.716a1.067 1.067 0 0 0-.76-.314 1.08 1.08 0 0 0-.758.314l-1.91 1.91a2.873 2.873 0 0 0 0 4.064l1.135 1.13ZM1.988 8.287l1.13 1.13a2.856 2.856 0 0 0 2.033.841 2.893 2.893 0 0 0 2.032-.84l1.91-1.91a1.067 1.067 0 0 0 .314-.76 1.08 1.08 0 0 0-.314-.758L5.379 2.276a1.076 1.076 0 0 0-1.62.097A9.087 9.087 0 0 0 2.086 6.07a7.964 7.964 0 0 0-.094 2.217h-.004Z" });
    case "plusCircle":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M11.47 17.03a.75.75 0 0 0 1.28-.53v-3.75h3.75a.75.75 0 0 0 0-1.5h-3.75V7.5a.75.75 0 1 0-1.5 0v3.75H7.5a.75.75 0 0 0 0 1.5h3.75v3.75c0 .199.08.39.22.53Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M4.388 21.276A12 12 0 0 0 12 24a11.92 11.92 0 0 0 8.485-3.515 12 12 0 1 0-16.098.791ZM6.168 3.27A10.5 10.5 0 0 1 12 1.5 10.512 10.512 0 0 1 22.5 12 10.5 10.5 0 1 1 6.167 3.27Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "print":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M20.625 15.75a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25ZM9.75 21h4.5a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0 0 1.5Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M17.25 0H6.75A.75.75 0 0 0 6 .75V4.5H4.677a2.238 2.238 0 0 0-2.013 1.244L.082 10.909A.75.75 0 0 0 0 11.25v6a2.253 2.253 0 0 0 2.25 2.25h2.985l-.72 3.6a.749.749 0 0 0 .735.9h13.5a.75.75 0 0 0 .735-.9l-.72-3.6h2.985A2.253 2.253 0 0 0 24 17.25v-6a.75.75 0 0 0-.082-.342l-2.582-5.164A2.238 2.238 0 0 0 19.323 4.5H18V.75a.75.75 0 0 0-.75-.75Zm-.75 5.247V7.5h-9v-6h9v3.747ZM18 6h1.324a.746.746 0 0 1 .671.415l2.042 4.085H1.964l2.042-4.085A.746.746 0 0 1 4.677 6H6v2.25a.75.75 0 0 0 .75.75h10.5a.75.75 0 0 0 .75-.75V6ZM1.5 17.25V12h21v5.25a.751.751 0 0 1-.75.75h-3.285l-.48-2.4a.75.75 0 0 0-.735-.6H6.75a.75.75 0 0 0-.735.6l-.48 2.4H2.25a.751.751 0 0 1-.75-.75Zm5.865-.75h9.27l1.2 6H6.165l1.2-6Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "reminder":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M1.067 4.355a.75.75 0 0 0 .902-.027l3.752-3A.75.75 0 0 0 4.783.155l-3.751 3a.75.75 0 0 0 .035 1.2ZM8.613 13.496h3.392a.748.748 0 0 0 .75-.75V7.495a.75.75 0 1 0-1.5 0v4.5H8.613a.75.75 0 0 0 0 1.501Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M12.005 22.5a9.754 9.754 0 0 1-4.294-.997L6.67 23.585a.75.75 0 1 1-1.342-.671l1.087-2.175a9.754 9.754 0 1 1 15.343-7.993 9.764 9.764 0 0 1-4.167 7.99l1.088 2.178A.75.75 0 0 1 18.01 24h-.001a.75.75 0 0 1-.671-.415L16.295 21.5a9.764 9.764 0 0 1-4.29.998Zm0-18.007a8.253 8.253 0 1 0 8.253 8.253 8.262 8.262 0 0 0-8.253-8.253Z",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M22.035 4.329a.747.747 0 0 0 .903.027.75.75 0 0 0 .035-1.198L19.22.157a.75.75 0 0 0-.937 1.17l3.751 3.002Z" })
      ] });
    case "search":
      return /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M10.112 18.713a8.612 8.612 0 0 1-8.569-7.743 8.604 8.604 0 0 1 6.85-9.297 8.613 8.613 0 0 1 9.94 5.883 8.604 8.604 0 0 1-1.64 8.099l5.595 5.595a.732.732 0 0 1-.518 1.249v.001a.732.732 0 0 1-.518-.215l-5.596-5.595a8.608 8.608 0 0 1-5.544 2.023Zm6.931-6.92a7.133 7.133 0 0 1-1.81 3.285.716.716 0 0 0-.154.155 7.138 7.138 0 0 1-11.683-2.69A7.131 7.131 0 0 1 5.85 4.39a7.138 7.138 0 0 1 4.257-1.41l-.003.002a7.094 7.094 0 0 1 6.572 4.343c.6 1.41.729 2.978.368 4.468Z",
          fillRule: "evenodd"
        }
      );
    case "success":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M10.595 15.992a1.5 1.5 0 0 0 .575.113h.107a1.506 1.506 0 0 0 1.09-.6l3.978-5.307a.75.75 0 0 0-1.2-.9l-3.977 5.307-2.388-2.387a.751.751 0 0 0-1.069-.009.748.748 0 0 0 .01 1.07l2.387 2.388c.14.14.305.25.487.325Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M13.025.232A2.37 2.37 0 0 0 11.998 0a2.367 2.367 0 0 0-1.854.886l-1.51 1.87a.876.876 0 0 1-.78.325l-2.4-.262a2.376 2.376 0 0 0-2.626 2.627l.262 2.4a.875.875 0 0 1-.324.78L.888 10.138a2.378 2.378 0 0 0 0 3.709l1.878 1.509a.88.88 0 0 1 .325.782l-.261 2.4a2.376 2.376 0 0 0 2.624 2.63l2.398-.261a.878.878 0 0 1 .786.324l1.51 1.88a2.376 2.376 0 0 0 3.706 0l1.506-1.875a.872.872 0 0 1 .779-.323l2.398.26a2.378 2.378 0 0 0 2.626-2.627l-.26-2.399a.875.875 0 0 1 .321-.78l1.889-1.507a2.38 2.38 0 0 0 0-3.708l-1.88-1.512a.876.876 0 0 1-.324-.78l.26-2.4a2.381 2.381 0 0 0-2.625-2.627l-2.398.26a.886.886 0 0 1-.784-.324L13.85.887a2.372 2.372 0 0 0-.825-.655Zm1.993 4.134a2.363 2.363 0 0 0 1.284.22l2.398-.26a.915.915 0 0 1 .46.07.881.881 0 0 1 .515.903l-.26 2.4a2.369 2.369 0 0 0 .875 2.112l1.879 1.51a.878.878 0 0 1 0 1.37l-1.888 1.507a2.372 2.372 0 0 0-.875 2.113l.26 2.4a.879.879 0 0 1-.973.972l-2.398-.261a2.37 2.37 0 0 0-2.11.875L12.68 22.17a.878.878 0 0 1-1.37 0L9.8 20.29a2.373 2.373 0 0 0-2.11-.875l-2.399.26a.875.875 0 0 1-.97-.974l.261-2.399a2.375 2.375 0 0 0-.875-2.113L1.83 12.68a.88.88 0 0 1 0-1.371l1.877-1.512a2.365 2.365 0 0 0 .876-2.112l-.261-2.4a.881.881 0 0 1 .973-.972l2.398.262a2.372 2.372 0 0 0 2.11-.874l1.51-1.871a.88.88 0 0 1 1.37 0l1.51 1.88c.223.278.505.503.825.657Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "swish":
      return /* @__PURE__ */ jsx("path", { d: "M17.174 1.168C12.354-1.137 6.404.004 2.808 4.287v.002c-.169.2-.33.404-.482.612-3.719 5.056-2.916 12.2 1.96 16.29l3.376-4.022a9.373 9.373 0 0 1-.084-14.292c2.664-2.302 6.408-2.954 9.596-1.709ZM21.192 19.713c-3.595 4.283-9.545 5.424-14.366 3.118 3.015 1.179 6.528.658 9.154-1.349a9.526 9.526 0 0 0 1.513-1.445A9.372 9.372 0 0 0 16.34 6.83l3.375-4.022c4.9 4.111 5.687 11.306 1.904 16.366-.128.172-.261.34-.398.505l-.028.033Z" });
    case "userPrivate":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M8.703 10.876c.976.652 2.124 1 3.299 1a5.945 5.945 0 0 0 5.938-5.938 5.938 5.938 0 1 0-9.237 4.938Zm.824-8.641a4.453 4.453 0 1 1 4.949 7.406 4.453 4.453 0 0 1-4.949-7.406Z",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M21.126 23.782a.742.742 0 0 0 1.267-.524 10.392 10.392 0 0 0-20.783 0 .742.742 0 1 0 1.485 0 8.908 8.908 0 0 1 17.814 0c0 .197.078.385.217.524Z" })
      ] });
    case "warning":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M12 14.25a.75.75 0 0 1-.75-.75V5.25a.75.75 0 1 1 1.5 0v8.25a.75.75 0 0 1-.75.75ZM12 18a1.125 1.125 0 1 1 0-2.25A1.125 1.125 0 0 1 12 18Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M4.388 21.276A12 12 0 0 0 12 24a11.92 11.92 0 0 0 8.485-3.515 12 12 0 1 0-16.098.791ZM6.168 3.27A10.5 10.5 0 0 1 12 1.5 10.512 10.512 0 0 1 22.5 12 10.5 10.5 0 1 1 6.167 3.27Z",
            fillRule: "evenodd"
          }
        )
      ] });
    case "xmark":
      return /* @__PURE__ */ jsx("path", { d: "M13.82 12.141a.183.183 0 0 1-.058-.14.211.211 0 0 1 .058-.14l7.333-7.33a1.189 1.189 0 1 0-1.682-1.683l-7.331 7.33a.2.2 0 0 1-.28 0l-7.332-7.33A1.189 1.189 0 0 0 2.847 4.53l7.332 7.331a.212.212 0 0 1 .058.14.184.184 0 0 1-.058.14l-7.332 7.331a1.203 1.203 0 0 0-.307 1.155 1.191 1.191 0 0 0 1.988.527l7.331-7.33a.2.2 0 0 1 .28 0l7.332 7.33a1.19 1.19 0 0 0 1.68-1.682l-7.33-7.33Z" });
    case "xmarkCircle":
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("path", { d: "M7.5 17.25a.75.75 0 0 1-.53-1.28L10.94 12 6.97 8.03a.75.75 0 1 1 1.062-1.06l3.97 3.97 3.969-3.97a.75.75 0 0 1 1.06 1.06L13.063 12l3.97 3.97a.75.75 0 0 1-.53 1.279l-.001.001a.749.749 0 0 1-.53-.22L12 13.06l-3.97 3.97a.748.748 0 0 1-.53.22Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M12 24a12 12 0 1 1 8.486-3.515A11.923 11.923 0 0 1 12 24Zm0-22.5A10.5 10.5 0 1 0 22.5 12 10.512 10.512 0 0 0 12 1.5Z",
            fillRule: "evenodd"
          }
        )
      ] });
    default:
      return null;
  }
}
var iconSizeClasses = {
  xs: `sds-w-3 sds-h-3`,
  sm: `sds-w-4 sds-h-4`,
  base: `sds-w-6 sds-h-6`,
  lg: `sds-w-10 sds-h-10`,
  xl: `sds-w-14 sds-h-14`
};
function Icon(_a) {
  var _b = _a, { icon, size } = _b, ariaAttributes = __objRest(_b, ["icon", "size"]);
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({}, ariaAttributes), {
      className: twMerge(
        "sds-reset sds-fill-current",
        size ? iconSizeClasses[size] : "sds-h-[1em] sds-w-[1em]"
      ),
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: getIcon(icon)
    })
  );
}
Icon.displayName = "Icon";

// tailwind-merge.config.ts
import { extendTailwindMerge } from "tailwind-merge";

// src/styles/tokens.ts
var COLORS = {
  transparent: "transparent",
  white: "#ffffff",
  "grey-50": "#fcfcfc",
  "grey-100": "#f9f9f9",
  "grey-200": "#f0f0f0",
  "grey-300": "#e8e8e8",
  "grey-400": "#dedede",
  "grey-500": "#d9d9d9",
  "grey-600": "#cecece",
  "grey-700": "#bbbbbb",
  "grey-800": "#686868",
  "grey-900": "#575757",
  "grey-1000": "#202020",
  "grey-50-a": "rgba(105, 105, 105, 0.0200)",
  "grey-100-a": "rgba(55, 55, 55, 0.0300)",
  "grey-200-a": "rgba(5, 5, 5, 0.0600)",
  "grey-300-a": "rgba(25, 25, 25, 0.1000)",
  "grey-400-a": "rgba(1, 1, 1, 0.1300)",
  "grey-500-a": "rgba(2, 2, 2, 0.1500)",
  "grey-600-a": "rgba(10, 10, 10, 0.2000)",
  "grey-700-a": "rgba(3, 3, 3, 0.2700)",
  "grey-800-a": "rgba(3, 3, 3, 0.6000)",
  "grey-900-a": "rgba(0, 0, 0, 0.6600)",
  "grey-1000-a": "rgba(2, 2, 2, 0.8800)",
  "slate-50": "#fcfcfd",
  "slate-100": "#f9f9fb",
  "slate-200": "#f0f0f3",
  "slate-300": "#e8e8ec",
  "slate-400": "#dddee3",
  "slate-500": "#d9d9e0",
  "slate-600": "#cdced6",
  "slate-700": "#b9bbc6",
  "slate-800": "#656971",
  "slate-900": "#53575f",
  "slate-1000": "#1c2024",
  "slate-50-a": "rgba(105, 105, 155, 0.0200)",
  "slate-100-a": "rgba(55, 55, 122, 0.0300)",
  "slate-200-a": "rgba(5, 5, 55, 0.0600)",
  "slate-300-a": "rgba(25, 25, 65, 0.1000)",
  "slate-400-a": "rgba(12, 19, 55, 0.1400)",
  "slate-500-a": "rgba(2, 2, 48, 0.1500)",
  "slate-600-a": "rgba(5, 10, 50, 0.2000)",
  "slate-700-a": "rgba(5, 12, 51, 0.2800)",
  "slate-800-a": "rgba(3, 9, 22, 0.6100)",
  "slate-900-a": "rgba(2, 8, 20, 0.6800)",
  "slate-1000-a": "rgba(3, 7, 12, 0.9000)",
  "cyan-50": "#fafdfe",
  "cyan-100": "#f3fbfd",
  "cyan-200": "#dff4fd",
  "cyan-300": "#d1effb",
  "cyan-400": "#bee6f4",
  "cyan-500": "#9bdcf0",
  "cyan-600": "#74cfe9",
  "cyan-700": "#43b8d8",
  "cyan-800": "#00738d",
  "cyan-900": "#005e73",
  "cyan-1000": "#032e39",
  "cyan-50-a": "rgba(5, 155, 205, 0.0200)",
  "cyan-100-a": "rgba(15, 175, 215, 0.0500)",
  "cyan-200-a": "rgba(9, 170, 240, 0.1300)",
  "cyan-300-a": "rgba(13, 171, 234, 0.1900)",
  "cyan-400-a": "rgba(5, 159, 213, 0.2600)",
  "cyan-500-a": "rgba(5, 168, 218, 0.4000)",
  "cyan-600-a": "rgba(2, 168, 215, 0.5500)",
  "cyan-700-a": "rgba(1, 159, 202, 0.7400)",
  "cyan-800-a": "#00738d",
  "cyan-900-a": "#005e73",
  "cyan-1000-a": "rgba(0, 44, 55, 0.9900)",
  "blue-50": "#fbfdff",
  "blue-100": "#f4faff",
  "blue-200": "#e5f4ff",
  "blue-300": "#d5eeff",
  "blue-400": "#c1e5fe",
  "blue-500": "#a6d8fa",
  "blue-600": "#8acaf4",
  "blue-700": "#55b3ec",
  "blue-800": "#1b709e",
  "blue-900": "#075c85",
  "blue-1000": "#002c44",
  "blue-50-a": "rgba(55, 155, 255, 0.0200)",
  "blue-100-a": "rgba(35, 155, 255, 0.0500)",
  "blue-200-a": "rgba(19, 155, 255, 0.1100)",
  "blue-300-a": "rgba(8, 155, 255, 0.1700)",
  "blue-400-a": "rgba(7, 151, 251, 0.2500)",
  "blue-500-a": "rgba(1, 144, 241, 0.3500)",
  "blue-600-a": "rgba(1, 140, 231, 0.4600)",
  "blue-700-a": "rgba(1, 142, 227, 0.6700)",
  "blue-800-a": "rgba(2, 96, 147, 0.9000)",
  "blue-900-a": "rgba(2, 89, 131, 0.9800)",
  "blue-1000-a": "#002c44",
  "green-50": "#fbfefb",
  "green-100": "#f5fbf5",
  "green-200": "#e9f6e9",
  "green-300": "#daf1db",
  "green-400": "#cbeacc",
  "green-500": "#b2ddb5",
  "green-600": "#9ad19f",
  "green-700": "#6dbe7b",
  "green-800": "#0b792d",
  "green-900": "#086424",
  "green-1000": "#152a18",
  "green-50-a": "rgba(55, 205, 55, 0.0200)",
  "green-100-a": "rgba(5, 155, 5, 0.0400)",
  "green-200-a": "rgba(11, 155, 11, 0.0900)",
  "green-300-a": "rgba(8, 162, 15, 0.1500)",
  "green-400-a": "rgba(7, 155, 12, 0.2100)",
  "green-500-a": "rgba(7, 145, 16, 0.3100)",
  "green-600-a": "rgba(3, 140, 15, 0.4000)",
  "green-700-a": "rgba(3, 143, 27, 0.5800)",
  "green-800-a": "rgba(1, 115, 36, 0.9600)",
  "green-900-a": "rgba(0, 95, 29, 0.9700)",
  "green-1000-a": "rgba(1, 23, 4, 0.9200)",
  "orange-50": "#fefcfb",
  "orange-100": "#fdf9f3",
  "orange-200": "#fcf2e5",
  "orange-300": "#f8e7d2",
  "orange-400": "#f7ddbd",
  "orange-500": "#eec998",
  "orange-600": "#e7b776",
  "orange-700": "#d99e47",
  "orange-800": "#955502",
  "orange-900": "#7d4b00",
  "orange-1000": "#342206",
  "orange-50-a": "rgba(205, 105, 55, 0.0200)",
  "orange-100-a": "rgba(215, 135, 15, 0.0500)",
  "orange-200-a": "rgba(228, 137, 19, 0.1100)",
  "orange-300-a": "rgba(216, 122, 5, 0.1800)",
  "orange-400-a": "rgba(224, 124, 1, 0.2600)",
  "orange-500-a": "rgba(214, 123, 4, 0.4100)",
  "orange-600-a": "rgba(211, 122, 1, 0.5400)",
  "orange-700-a": "rgba(203, 122, 3, 0.7300)",
  "orange-800-a": "#955502",
  "orange-900-a": "#7d4b00",
  "orange-1000-a": "rgba(48, 29, 1, 0.9800)",
  "red-50": "#fffcfb",
  "red-100": "#fff8f7",
  "red-200": "#feefec",
  "red-300": "#fee3dd",
  "red-400": "#fdd5cc",
  "red-500": "#fabeb1",
  "red-600": "#f5a897",
  "red-700": "#ed8b76",
  "red-800": "#ba2d10",
  "red-900": "#a11f02",
  "red-1000": "#4a1106",
  "red-50-a": "rgba(255, 105, 55, 0.0200)",
  "red-100-a": "rgba(255, 80, 55, 0.0400)",
  "red-200-a": "rgba(243, 55, 18, 0.0800)",
  "red-300-a": "rgba(248, 55, 12, 0.1400)",
  "red-400-a": "rgba(245, 45, 0, 0.2000)",
  "red-500-a": "rgba(239, 45, 3, 0.3100)",
  "red-600-a": "rgba(231, 43, 1, 0.4100)",
  "red-700-a": "rgba(222, 40, 1, 0.5400)",
  "red-800-a": "rgba(182, 32, 1, 0.9400)",
  "red-900-a": "#a11f02",
  "red-1000-a": "rgba(70, 12, 1, 0.9800)"
};
var BACKGROUNDS = {
  bg: COLORS["slate-100"],
  "bg-secondary": COLORS["slate-50"],
  "bg-inverse": COLORS["blue-1000"]
};
var SURFACES = {
  "bg-surface": COLORS.white,
  "bg-surface-hover": COLORS["slate-50"],
  "bg-surface-active": COLORS["slate-200"],
  "bg-surface-selected": COLORS["slate-300"],
  "bg-surface-disabled": COLORS["grey-100-a"],
  "bg-surface-transparent": COLORS.transparent,
  "bg-surface-secondary": COLORS["slate-50"],
  "bg-surface-secondary-hover": COLORS["slate-200"],
  "bg-surface-secondary-active": COLORS["slate-300"],
  "bg-surface-info": COLORS["blue-200"],
  "bg-surface-info-hover": COLORS["blue-300"],
  "bg-surface-info-active": COLORS["blue-400"],
  "bg-surface-success": COLORS["green-200"],
  "bg-surface-success-hover": COLORS["green-300"],
  "bg-surface-success-active": COLORS["green-400"]
};
var FILLS = {
  "bg-fill": COLORS.white,
  "bg-fill-hover": COLORS["slate-100"],
  "bg-fill-active": COLORS["slate-200"],
  "bg-fill-selected": COLORS["slate-500"],
  "bg-fill-disabled": COLORS["grey-200-a"],
  "bg-fill-brand": COLORS["blue-800"],
  "bg-fill-brand-hover": COLORS["blue-900"],
  "bg-fill-brand-active": COLORS["blue-1000"],
  "bg-fill-brand-selected": COLORS["blue-1000"],
  "bg-fill-brand-disabled": COLORS["grey-300-a"],
  "bg-fill-transparent-brand": COLORS.transparent,
  "bg-fill-transparent-brand-hover": COLORS["blue-200-a"],
  "bg-fill-transparent-brand-active": COLORS["blue-300-a"]
};
var TEXTS = {
  text: COLORS["slate-1000"],
  "text-secondary": COLORS["slate-900"],
  "text-disabled": COLORS["grey-700-a"],
  "text-link": COLORS["blue-800"],
  "text-link-hover": COLORS["blue-900"],
  "text-link-active": COLORS["blue-1000"],
  "text-brand": COLORS["blue-800"],
  "text-brand-hover": COLORS["blue-900"],
  "text-brand-active": COLORS["blue-1000"],
  "text-brand-on-bg-fill": COLORS.white,
  "text-transparent": COLORS.transparent
};
var BORDERS = {
  "border-brand": COLORS["blue-800"],
  "border-transparent": COLORS.transparent,
  "border-focus": COLORS["blue-800"]
};
var TEXT_HEADINGS = {
  h1: ["3.125rem", { lineHeight: "4rem" }],
  h2: ["2rem", { lineHeight: "2.5rem" }],
  h3: ["1.5rem", { lineHeight: "2rem" }],
  h4: ["1.25rem", { lineHeight: "1.75rem" }],
  h5: ["1rem", { lineHeight: "1.75rem" }]
};
var TEXT_BODIES = {
  default: ["1rem", { lineHeight: "1.75rem" }],
  "default-dense": ["1rem", { lineHeight: "1.5rem" }],
  small: ["0.875rem", { lineHeight: "1.5rem" }],
  "small-dense": ["0.875rem", { lineHeight: "1.25rem" }],
  caption: ["0.75rem", { lineHeight: "1.25rem" }],
  "caption-dense": ["0.75rem", { lineHeight: "1rem" }]
};

// tailwind-merge.config.ts
var fontSizesHeadings = Object.keys(TEXT_HEADINGS);
var fontSizesBodies = Object.keys(TEXT_BODIES);
var fontSizes = [...fontSizesHeadings, ...fontSizesBodies];
var twMerge2 = extendTailwindMerge({
  prefix: "sds-",
  extend: {
    classGroups: {
      "font-size": [
        {
          text: fontSizes
        }
      ],
      "text-color": [{ text: Object.keys(TEXTS) }]
    }
  }
});

// src/components/Spinner/Spinner.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var spinnerSizeClasses = {
  sm: `sds-w-4`,
  base: `sds-w-6`
};
function Spinner(_a) {
  var _b = _a, { size = "base" } = _b, ariaAttributes = __objRest(_b, ["size"]);
  return /* @__PURE__ */ jsx2(
    "svg",
    __spreadProps(__spreadValues({}, ariaAttributes), {
      className: twMerge2("sds-reset", spinnerSizeClasses[size], "sds-stroke-current sds-h-full"),
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx2("g", { className: "sds-origin-center sds-animate-rotate", children: /* @__PURE__ */ jsx2(
        "circle",
        {
          className: "sds-animate-loading",
          cx: "12",
          cy: "12",
          fill: "none",
          r: "10",
          strokeLinecap: "round",
          strokeWidth: "2"
        }
      ) })
    })
  );
}
Spinner.displayName = "Spinner";

// src/components/Button/Button.tsx
import { useRef } from "react";
import { useButton, mergeProps } from "react-aria";
import { FocusRing } from "react-aria";

// src/components/Utility/Loader.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
function withLoader(Component) {
  function WrappedComponent(_a) {
    var _b = _a, { isLoading, spinnerSize } = _b, props = __objRest(_b, ["isLoading", "spinnerSize"]);
    if (!isLoading) return /* @__PURE__ */ jsx3(Component, __spreadValues({}, props));
    return /* @__PURE__ */ jsx3(Spinner, { size: spinnerSize });
  }
  return WrappedComponent;
}

// src/components/Button/Button.tsx
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var variantClasses = {
  primary: `
    sds-gap-2
    sds-ring-2
    sds-ring-inset
    sds-px-5
    sds-py-2
    sds-items-center
    sds-justify-center
    sds-text-center
    sds-text-default-dense
    sds-font-semibold
    sds-ring-bg-fill-brand
    sds-bg-bg-fill-brand
    sds-text-text-brand-on-bg-fill
    hover:sds-ring-bg-fill-brand-hover
    hover:sds-bg-bg-fill-brand-hover
    active:sds-ring-bg-fill-brand-active
    active:sds-bg-bg-fill-brand-active
    aria-disabled:sds-ring-0
    aria-disabled:sds-bg-bg-fill-brand-disabled
    aria-disabled:sds-ring-bg-fill-brand-disabled
    aria-disabled:hover:sds-bg-bg-fill-brand-disabled
    aria-disabled:hover:sds-ring-bg-fill-brand-disabled
    aria-disabled:active:sds-bg-bg-fill-brand-disabled
    aria-disabled:active:sds-ring-bg-fill-brand-disabled
    loading:sds-text-text-brand-on-bg-fill
    loading:sds-ring-bg-fill-brand-active
    loading:sds-bg-bg-fill-brand-active
    loading:hover:sds-ring-bg-fill-brand-active
    loading:hover:sds-bg-bg-fill-brand-active
    loading:active:sds-bg-bg-fill-brand-active
  `,
  secondary: `
    sds-gap-2
    sds-ring-2
    sds-ring-inset
    sds-px-5
    sds-py-2
    sds-items-center
    sds-justify-center
    sds-text-center
    sds-text-default-dense
    sds-font-semibold
    sds-ring-bg-fill-brand
    sds-text-text-brand
    hover:sds-ring-bg-fill-brand-hover
    hover:sds-bg-bg-fill-brand-hover
    hover:sds-text-text-brand-on-bg-fill
    active:sds-ring-bg-fill-brand-active
    active:sds-bg-bg-fill-brand-active
    active:sds-text-text-brand-on-bg-fill
    aria-disabled:sds-ring-0
    aria-disabled:sds-bg-bg-fill-brand-disabled
    aria-disabled:sds-ring-bg-fill-brand-disabled
    aria-disabled:hover:sds-bg-bg-fill-brand-disabled
    aria-disabled:hover:sds-ring-bg-fill-brand-disabled
    aria-disabled:active:sds-text-text-disabled
    aria-disabled:active:sds-bg-bg-fill-brand-disabled
    aria-disabled:active:sds-ring-bg-fill-brand-disabled
    loading:sds-text-text-brand-on-bg-fill
    loading:sds-ring-bg-fill-brand-active
    loading:sds-bg-bg-fill-brand-active
    loading:hover:sds-ring-bg-fill-brand-active
    loading:hover:sds-bg-bg-fill-brand-active
  `,
  plain: `
    sds-gap-2
    sds-px-5
    sds-py-2
    sds-items-center
    sds-justify-center
    sds-text-center
    sds-text-default-dense
    sds-font-semibold
    sds-text-text-brand
    hover:sds-bg-bg-fill-transparent-brand-hover
    hover:sds-text-text-brand-hover
    active:sds-bg-bg-fill-transparent-brand-active
    active:sds-text-text-brand-active
    aria-disabled:hover:sds-text-text-disabled
    aria-disabled:hover:sds-bg-bg-fill-transparent-brand
    aria-disabled:hover:sds-ring-bg-fill-transparent-brand
    aria-disabled:active:sds-text-text-disabled
    aria-disabled:active:sds-bg-bg-fill-transparent-brand
    aria-disabled:active:sds-ring-bg-fill-transparent-brand
    loading:sds-bg-bg-fill-transparent-brand-active
    loading:sds-text-text-brand-active
    loading:hover:sds-bg-bg-fill-transparent-brand-active
    loading:hover:sds-text-text-brand-active
    loading:active:sds-bg-bg-fill-transparent-brand-active
    loading:active:sds-text-text-brand-active
  `,
  icon: `
    sds-p-2
    sds-text-text-brand
    hover:sds-bg-bg-fill-transparent-brand-hover
    hover:sds-text-text-brand-hover
    active:sds-bg-bg-fill-transparent-brand-active
    active:sds-text-text-brand-active
    aria-disabled:sds-ring-0
    aria-disabled:sds-ring-bg-fill-brand-disabled
    aria-disabled:sds-bg-bg-fill-transparent-brand
    aria-disabled:hover:sds-ring-bg-fill-brand-disabled
    aria-disabled:active:sds-text-text-disabled
    aria-disabled:active:sds-ring-bg-fill-brand-disabled
    loading:sds-bg-bg-fill-transparent-brand-active
    loading:sds-text-text-brand-active
    loading:hover:sds-bg-bg-fill-transparent-brand-active
    loading:hover:sds-text-text-brand-active
    loading:active:sds-bg-bg-fill-transparent-brand-active
    loading:active:sds-text-text-brand-active
  `
};
var smallClasses = {
  primary: `
    sds-px-4
    sds-py-1
    sds-text-small
  `,
  secondary: `
    sds-px-4
    sds-py-1
    sds-text-small
  `,
  plain: `
    sds-px-4
    sds-py-1
    sds-text-small
  `,
  icon: `
    sds-p-2
  `
};
var shapeClasses = {
  rectangular: `
    sds-rounded-lg
  `,
  rounded: `
    sds-rounded-full
  `
};
var baseClasses = `
  sds-font-sans
  sds-relative
  sds-flex
  sds-cursor-pointer
  sds-transition-[colors,shadow]
  sds-ease-in-out
  sds-select-none
  aria-disabled:sds-cursor-not-allowed
  aria-disabled:sds-text-text-disabled
  sds-outline-none
`;
var focusRingClasses = `
  sds-outline
  sds-outline-2
  sds-outline-offset-2
  sds-outline-border-focus
`;
function handleDisabledClick(onClick, disabled) {
  if (onClick && !disabled)
    return (e) => {
      onClick(e);
    };
  return void 0;
}
var getClasses = (variant, size, shape) => twMerge2(
  baseClasses,
  variantClasses[variant],
  shapeClasses[shape],
  size === "sm" && smallClasses[variant]
);
var IconWithLoader = withLoader(Icon);
function TextButton(props) {
  const _a = props, {
    iconStart,
    iconEnd,
    children,
    onClick,
    disabledLabel,
    type = "button",
    fullWidth = false,
    disabled = false,
    loading = false,
    variant = "primary",
    size = "base",
    shape = "rectangular"
  } = _a, buttonHtmlAttributes = __objRest(_a, [
    "iconStart",
    "iconEnd",
    "children",
    "onClick",
    "disabledLabel",
    "type",
    "fullWidth",
    "disabled",
    "loading",
    "variant",
    "size",
    "shape"
  ]);
  const ref = useRef(null);
  const { buttonProps } = useButton(
    {
      onPress: handleDisabledClick(onClick, disabled)
    },
    ref
  );
  const mergedProps = mergeProps(buttonProps, buttonHtmlAttributes);
  return /* @__PURE__ */ jsx4(FocusRing, { focusRingClass: focusRingClasses, children: /* @__PURE__ */ jsxs2(
    "button",
    __spreadProps(__spreadValues({}, mergedProps), {
      "aria-busy": loading,
      "aria-disabled": disabled ? "true" : void 0,
      className: twMerge2(
        "sds-reset",
        getClasses(variant, size, shape),
        fullWidth && "sds-w-full"
      ),
      ref,
      title: disabled && disabledLabel ? disabledLabel : void 0,
      type,
      children: [
        iconStart ? /* @__PURE__ */ jsx4(IconWithLoader, { icon: iconStart, isLoading: loading, size, spinnerSize: size }) : null,
        /* @__PURE__ */ jsx4("span", { className: loading && !iconStart && !iconEnd ? "sds-invisible" : void 0, children }),
        loading && !iconStart && !iconEnd ? /* @__PURE__ */ jsx4("span", { className: "sds-absolute", children: /* @__PURE__ */ jsx4(Spinner, { size }) }) : null,
        iconEnd ? /* @__PURE__ */ jsx4(IconWithLoader, { icon: iconEnd, isLoading: loading, size, spinnerSize: size }) : null
      ]
    })
  ) });
}
function IconButton(props) {
  const _a = props, {
    icon,
    variant,
    onClick,
    disabledLabel,
    type = "button",
    loading = false,
    disabled = false,
    size = "base",
    shape = "rectangular"
  } = _a, buttonHtmlAttributes = __objRest(_a, [
    "icon",
    "variant",
    "onClick",
    "disabledLabel",
    "type",
    "loading",
    "disabled",
    "size",
    "shape"
  ]);
  const ref = useRef(null);
  const { buttonProps } = useButton(
    {
      onPress: handleDisabledClick(onClick, disabled)
    },
    ref
  );
  const mergedProps = mergeProps(buttonProps, buttonHtmlAttributes);
  return /* @__PURE__ */ jsx4(FocusRing, { focusRingClass: focusRingClasses, children: /* @__PURE__ */ jsx4(
    "button",
    __spreadProps(__spreadValues({}, mergedProps), {
      "aria-busy": loading,
      "aria-disabled": disabled ? "true" : void 0,
      className: twMerge2("sds-reset", getClasses(variant, size, shape)),
      ref,
      title: disabled && disabledLabel ? disabledLabel : void 0,
      type,
      children: /* @__PURE__ */ jsx4(IconWithLoader, { icon, isLoading: loading, size, spinnerSize: size })
    })
  ) });
}
function Button(props) {
  return props.variant === "icon" ? /* @__PURE__ */ jsx4(IconButton, __spreadValues({}, props)) : /* @__PURE__ */ jsx4(TextButton, __spreadValues({}, props));
}
Button.displayName = "Button";

// src/components/Anchor/Anchor.tsx
import "react";
import { twMerge as twMerge3 } from "tailwind-merge";
import { jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var baseClasses2 = `
  sds-reset
  sds-text-text-link
  sds-inline-flex
  sds-flex-row
  sds-items-baseline
  sds-gap-1
  hover:sds-text-text-link-hover
  active:sds-text-text-link-active
  focus-visible:sds-outline
  focus-visible:sds-outline-2
  focus-visible:sds-outline-offset-4
  focus-visible:sds-rounded-sm
  focus-visible:sds-outline-border-focus
`;
function Anchor(_a) {
  var _b = _a, {
    as,
    children,
    iconStart,
    iconEnd,
    underline = false
  } = _b, otherProps = __objRest(_b, [
    "as",
    "children",
    "iconStart",
    "iconEnd",
    "underline"
  ]);
  const Component = as || "a";
  const anchorClasses = twMerge3(baseClasses2, underline && "sds-underline sds-underline-offset-2");
  return /* @__PURE__ */ jsxs3(Component, __spreadProps(__spreadValues({ className: anchorClasses }, otherProps), { children: [
    iconStart ? /* @__PURE__ */ jsx5("span", { className: "sds-self-center", children: /* @__PURE__ */ jsx5(Icon, { icon: iconStart }) }) : null,
    children,
    iconEnd ? /* @__PURE__ */ jsx5("span", { className: "sds-self-center", children: /* @__PURE__ */ jsx5(Icon, { icon: iconEnd }) }) : null
  ] }));
}
Anchor.displayName = "Anchor";

// src/components/Alert/Alert.tsx
import { twMerge as twMerge4 } from "tailwind-merge";
import { useId } from "react-aria";
import { jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var kindIcon = {
  information: `information`,
  success: `success`,
  warning: `warning`,
  error: `alert`,
  pending: `pending`
};
var kindClasses = {
  // TODO: Swap to tokens
  information: `sds-bg-[#e5f4ff] sds-border sds-border-[#8acaf4] sds-text-[#002c44]`,
  success: `sds-bg-[#e9f6e9] sds-border sds-border-[#9ad19f] sds-text-[#152a18]`,
  warning: `sds-bg-[#fcf2e5] sds-border sds-border-[#e7b776] sds-text-[#342206]`,
  error: `sds-bg-[#feefec] sds-border sds-border-[#f5a897] sds-text-[#4a1106]`,
  pending: `sds-bg-[#f0f0f3] sds-border sds-border-[#cdced6] sds-text-[#1c2024]`
};
var kindIconColorClasses = {
  // TODO: Swap to tokens
  information: `sds-text-[#1b709e]`,
  success: `sds-text-[#0b792d]`,
  warning: `sds-text-[#955502]`,
  error: `sds-text-[#ba2d10]`,
  pending: `sds-text-[#656971]`
};
var baseClasses3 = `
  sds-reset
  sds-relative
  sds-grid
  sds-grid-cols-[1fr_auto]
  sds-items-start
  sds-gap-3
  sds-overflow-clip
  sds-rounded-lg
  sds-pt-2
  sds-pr-2
  sds-pb-4
  sds-pl-4
  sds-font-sans
  sds-text-left
  before:sds-absolute
  before:sds-left-0
  before:sds-top-0
  before:sds-h-full
  before:sds-w-[5px]
`;
function Alert({
  kind,
  children,
  onClose,
  dismissible = false,
  hasIcon = true,
  title,
  anchors,
  role,
  button
}) {
  const titleId = useId();
  return /* @__PURE__ */ jsxs4(
    "div",
    {
      "aria-labelledby": titleId,
      className: twMerge4(baseClasses3, kindClasses[kind]),
      role: role || (button ? "alertdialog" : "status"),
      children: [
        /* @__PURE__ */ jsxs4(
          "div",
          {
            className: twMerge4(
              "sds-pt-2 sds-grid sds-gap-3 sds-items-start",
              hasIcon && "sds-grid-cols-[auto_1fr]"
            ),
            children: [
              hasIcon ? /* @__PURE__ */ jsx6("div", { "aria-hidden": true, className: twMerge4(kindIconColorClasses[kind]), children: /* @__PURE__ */ jsx6(Icon, { "aria-hidden": true, icon: kindIcon[kind], size: "base" }) }) : null,
              /* @__PURE__ */ jsxs4("div", { children: [
                title ? /* @__PURE__ */ jsx6(
                  "div",
                  {
                    className: twMerge4("sds-text-default-dense sds-font-semibold sds-mb-2"),
                    id: titleId,
                    children: title
                  }
                ) : null,
                /* @__PURE__ */ jsx6("p", { className: twMerge4("sds-text-default-dense"), children }),
                anchors ? /* @__PURE__ */ jsx6("div", { className: "sds-flex sds-flex-col sds-gap-3 sds-mt-3 sds-text-default-dense", children: anchors }) : null,
                button ? /* @__PURE__ */ jsx6("div", { className: "sds-mt-3", children: button }) : null
              ] })
            ]
          }
        ),
        dismissible ? /* @__PURE__ */ jsx6(Button, { "aria-label": "Close alert", icon: "xmark", onClick: onClose, size: "sm", variant: "icon" }) : null
      ]
    }
  );
}
Alert.displayName = "Alert";

// src/components/Tooltip/Tooltip.tsx
import "react";
import { TooltipTrigger, Tooltip as ReactAriaTooltip, OverlayArrow } from "react-aria-components";
import { jsx as jsx7, jsxs as jsxs5 } from "react/jsx-runtime";
var baseClasses4 = `
  sds-reset
  sds-tooltip
  sds-font-sans
  sds-min-w-28
  sds-max-w-72
  sds-bg-bg-inverse
  sds-text-text-brand-on-bg-fill
  sds-inline-block
  sds-text-small-dense
  sds-shadow-[0_2px_8px_rgba(0,0,0,0.2)]
  sds-animate-fadeIn
  sds-cursor-default
  sds-break-words
  sds-p-4
  sds-m-2.5
  sds-text-left
  sds-rounded-lg
`;
var smallClasses2 = `
  sds-min-w-[unset]
  sds-max-w-52
  sds-py-1
  sds-px-4
  sds-m-2
  sds-text-center
  sds-rounded
`;
function Tooltip(_a) {
  var _b = _a, {
    title,
    text,
    variant = "base",
    placement,
    children,
    zIndex = 999999
  } = _b, props = __objRest(_b, [
    "title",
    "text",
    "variant",
    "placement",
    "children",
    "zIndex"
  ]);
  const tooltipClasses = twMerge2(baseClasses4, variant === "sm" && smallClasses2);
  const tooltipArrowClasses = twMerge2(
    placement === "left" && "sds-rotate-[270deg]",
    placement === "bottom" && "sds-rotate-[180deg]",
    placement === "right" && "sds-rotate-[90deg]",
    placement !== "left" && placement !== "bottom" && placement !== "right" && "sds-rotate-[0deg]"
  );
  return /* @__PURE__ */ jsxs5(TooltipTrigger, { delay: 300, children: [
    children,
    /* @__PURE__ */ jsxs5(
      ReactAriaTooltip,
      __spreadProps(__spreadValues({}, props), {
        className: tooltipClasses,
        placement,
        style: { zIndex },
        children: [
          /* @__PURE__ */ jsx7(OverlayArrow, { children: variant === "base" ? /* @__PURE__ */ jsx7(
            "svg",
            {
              "aria-hidden": true,
              className: tooltipArrowClasses,
              height: 12,
              viewBox: "0 0 12 12",
              width: 12,
              children: /* @__PURE__ */ jsx7("path", { className: "sds-fill-bg-fill-brand-active", d: "M0 0 L6 6 L12 0" })
            }
          ) : /* @__PURE__ */ jsx7("svg", { "aria-hidden": true, className: tooltipArrowClasses, height: 8, viewBox: "0 0 8 8", width: 8, children: /* @__PURE__ */ jsx7("path", { className: "sds-fill-bg-fill-brand-active", d: "M0 0 L4 4 L8 0" }) }) }),
          variant === "base" && title ? /* @__PURE__ */ jsx7("div", { className: "sds-font-medium sds-cursor-default sds-mb-1", children: title }) : null,
          /* @__PURE__ */ jsx7("div", { className: "sds-cursor-default", children: text })
        ]
      })
    )
  ] });
}
Tooltip.displayName = "Tooltip";
export {
  Alert,
  Anchor,
  Button,
  SSRProvider,
  Tooltip
};
